export default __webpack_public_path__ + "static/media/lydian-trading-academy.552b0420.png";